<template>
  <div id="oferta">
    <section class="section-whitespace" v-for="(item, index) in items" :key="index">
      <div class="row">
        <div class="small-12 medium-6 columns">
          <h2>
            {{ item.name }}
          </h2>
        </div>
      </div>
      <div class="row" v-for="(post, postIndex) in item.items" :key="postIndex">
        <div class="small-11 small-offset-1 medium-offset-0 medium-5 columns">
          <strong>– {{ post.post_title }}</strong>
        </div>
        <div class="small-10 small-offset-2 medium-offset-0 medium-6 columns" v-html="post.post_content"></div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: []
    }
  },
  beforeCreate: function () {
    this.$http.get(`tax/v1/terms/oferta/offer-type`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Offer.vue